import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SpinnerComponent } from '@coreui/angular';

/**
 * Auth0 callback / transit route (`/login`).
 *
 * This is the registered Auth0 `redirect_uri`, so Auth0 lands here after login.
 * It renders no login UI — the only login screen is the root `/` LoginComponent.
 *
 * - When Auth0 redirects back with `?code=&state=` (or `?error=`), the SDK is
 *   mid-callback and will navigateByUrl(appState.target) once it finishes. Don't
 *   race it — just wait.
 * - Any other landing on `/login` (e.g. logout returnTo, a stale bookmark) is
 *   bounced to `/`, where the single Sign In button lives.
 */
@Component({
    standalone: true,
    imports: [SpinnerComponent],
    template: `
        <div class="bg-body min-vh-100 d-flex align-items-center justify-content-center">
            <c-spinner color="primary" />
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthCallbackComponent implements OnInit {
    constructor(private router: Router) {}

    ngOnInit() {
        const params = new URLSearchParams(window.location.search);
        const isCallback = (params.has('code') && params.has('state')) || params.has('error');
        if (isCallback) return;

        this.router.navigate(['/']);
    }
}
